import Language from '@/constants/Language';
import Button from '@/shared/Button/Button';
import { StyledSubscriptionLanguageSelector } from '../Subscriptions.styled';

export default function SubscriptionLanguageSelector({
  selectedLanguage,
  setSelectedLanguage,
}) {
  return (
    <StyledSubscriptionLanguageSelector>
      <h3>Choose your language:</h3>
      <div className="language-buttons">
        <Button
          type="white"
          className={selectedLanguage == 'es' ? 'selected' : ''}
          onClick={() => setSelectedLanguage('es')}
        >
          <span className="button-text">
            <span>Spanish</span>
          </span>
        </Button>
        <Button
          type="white"
          className={selectedLanguage == 'fr' ? 'selected' : ''}
          onClick={() => setSelectedLanguage('fr')}
        >
          <span className="button-text">
            <span>French</span>
          </span>
        </Button>
        <Button
          type="white"
          className={selectedLanguage == 'all' ? 'selected' : ''}
          onClick={() => setSelectedLanguage('all')}
        >
          <span className="button-text">
            <span>Spanish & French</span>
          </span>
        </Button>
      </div>
    </StyledSubscriptionLanguageSelector>
  );
}
